//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

// #region Imports
import { EthAddr } from '@shared/SchemaTypes'
import { Signer } from 'ethers'

import { ActivityEnum, RoleEnum } from '@shared/Enums'

import { poolActions } from '@react/redux/poolSlice'

import { logOT } from '@shared/loggingShared'

import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'

import { assertRole, dispatchError, OtStoreState } from '@react/redux/store'

import { UserConnection } from '@shared/DeploymentConfigTypes'
import { dailyInterestAccrualForFlex } from '@shared/poolActions'

export const dailyInterestAccrualForFlexTx =
  (props: { poolAddr: EthAddr }): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<void> => {
    const activity = ActivityEnum.DAILY_ACCRUAL_FLEX
    try {
      const { webSocket } = getState().chainState
      const { chainConfigurationName } = getState().chainState.chainConfiguration
      const { roleEnum, signer } = getState().chainState.userConnection as UserConnection
      assertRole(roleEnum, RoleEnum.POOL_ADMIN)
      const { poolAddr } = props

      logOT.debug('dailyAccrualFlexSaga', poolAddr)
      await dailyInterestAccrualForFlex(webSocket, signer as Signer, poolAddr, chainConfigurationName)
      dispatch(poolActions.dailyAccrualFlexSuccess(props))
    } catch (e: any) {
      dispatch(poolActions.dailyAccrualFlexFail(props))
      await dispatchError(dispatch, e, activity, 1020)
    }
  }
